import Dataset from "datasets/types/interfaces/dataset";
import { useFetcher } from "~/hooks/useFetcher";

const { VITE_CATALOG_API } = import.meta.env;

interface UseDatasetOptions {
  offset?: number;
  limit?: number;
  sortBy?: "title" | "createdAt" | "updatedAt";
  sortOrder?: "asc" | "desc";
}

const useDatasets = (options: UseDatasetOptions = {}) => {
  // TODO: Adjust limit when pagination properly implemented
  const { offset = 0, limit = 1000, sortBy = "updatedAt", sortOrder = "desc" } = options;

  let url = `${VITE_CATALOG_API}/datasets?offset=${offset}&limit=${limit}`;

  if (sortBy) {
    url += `&sort_by=${sortBy}&sort_order=${sortOrder}`;
  }
  return useFetcher<Dataset[]>(url);
};

export default useDatasets;
